const CarouselOffers = {
    $swipers: [],
    swipers: {},

    init() {
        this.$swipers = document.querySelectorAll('.offers-swiper');

        this.$swipers.forEach(($swiper, index) => {
            this.initSwiper($swiper, index);
        });

    },

    initSwiper($swiper, name) {
        const $slides = $swiper.querySelectorAll('.swiper-slide');
        let args = {
            updateOnWindowResize: true,
            slidesPerView: 1,
            loop: false,
            allowTouchMove: true,
            threshold: 10,
            spaceBetween: 140,
            navigation: {
                prevEl: '.swiper-button-prev',
                nextEl: '.swiper-button-next',
            },
            pagination: $slides.length > 1 ? {
                el: '.swiper-pagination',
                clickable: true,
            } : false,
            breakpoints: {},
        };

        this.swipers[name] = new Swiper($swiper, args);
    }
}

export default CarouselOffers;